import { FloatingFormItem, PlanAccountsSelect } from '@/components/_common';
import { PlanAccountOrderBy } from '@/core/domain/enterprise/PlanAccounts/PlanAccounts.types';
import { FilterExpensesBy } from '@/core/domain/NetReport/Financial/Financial.types';
import { Col, Collapse, Row, Select } from 'antd';
import { useIntl } from 'react-intl';

const BalanceteMoreOptions = () => {
  const intl = useIntl().formatMessage;

  const optionsFilterExpensesBy = [
    {
      value: FilterExpensesBy.fixedExpenses,
      label: intl({
        id: 'financial.billsToPay.form.filterExpensesBy.fixedExpenses',
      }),
    },
    {
      value: FilterExpensesBy.variableExpenses,
      label: intl({
        id: 'financial.billsToPay.form.filterExpensesBy.variableExpenses',
      }),
    },
    {
      value: FilterExpensesBy.withoutClassification,
      label: intl({
        id: 'financial.billsToPay.form.filterExpensesBy.withoutClassification',
      }),
    },
  ];

  return (
    <Collapse>
      <Collapse.Panel
        key={1}
        header={intl({ id: 'financial.billsToPay.form.moreOptions' })}
      >
        <Row gutter={[24, 24]}>
          <Col xs={12}>
            <FloatingFormItem
              name="expenseFilterBy"
              label={intl({ id: 'financial.billsToPay.form.filterExpensesBy' })}
            >
              <Select allowClear options={optionsFilterExpensesBy} />
            </FloatingFormItem>
          </Col>

          <Col xs={12}>
            <FloatingFormItem
              name="planAccountIds"
              label={intl({ id: 'financial.billsToPay.form.chartOfAccounts' })}
            >
              <PlanAccountsSelect
                allowClear
                mode="multiple"
                queryFilter={{ orderBy: PlanAccountOrderBy.DESCRIPTION }}
              />
            </FloatingFormItem>
          </Col>
        </Row>
      </Collapse.Panel>
    </Collapse>
  );
};

export default BalanceteMoreOptions;
